<template>
  <div class="position-selector" :class="{disabled}">
    <template v-if="compact">
      <div
        v-for="position in positions"
        :key="position.key"
        class="position position-compact"
        :class="{ active: value === position.key }"
      >
        <div class="position-card" :class="cardClasses(position)">
          <img :src="positionIcons[position.key]" :alt="`${position.label.en} position icon`">
        </div>
        <div
          v-if="position.key === value"
          class="position-label"
        >
          Starting Position
        </div>
      </div>
    </template>
    <template v-else>
      <md-button
        v-for="position in positions"
        :key="position.key"
        :disabled="disabled"
        class="position"
        :class="{ active: value === position.key }"
        @click="updatePosition(position.key)"
      >
        <span>{{ position.label.en }}</span>
        <div class="position-card">
          <img :src="positionIcons[position.key]" :alt="`${position.label.en} position icon`">
        </div>
      </md-button>
    </template>
  </div>
</template>

<script>
import positions from '~lib/common/config/positions';

import seatedForwardIcon from '../../assets/positions/seated-forward.svg';
import sideIcon from '../../assets/positions/side.svg';
import layingDownIcon from '../../assets/positions/laying-down.svg';
import proneIcon from '../../assets/positions/prone.svg';
import fowlerIcon from '../../assets/positions/fowler.svg';

export default {
  name: 'position-selector',
  props: {
    value: {
      type: String,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    useDefault: {
      type: Boolean,
      default: false,
    },
    compact: {
      type: Boolean,
      default: false,
    },
    validStances: {
      type: Array,
      default: null,
    },
  },
  data() {
    return {
      positions,
      positionIcons: {
        SIT: seatedForwardIcon,
        LAY: layingDownIcon,
        FOWLER: fowlerIcon,
        PRONE: proneIcon,
        SIDE: sideIcon,
      }
    };
  },
  created() {
    if (this.useDefault) {
      this.updatePosition(positions[0].key);
    }
  },
  methods: {
    cardClasses(position) {
      return {
        'position-card-compact': this.compact,
        'position-card-valid': this.validStances != null && this.validStances.includes(position.key),
        'position-card-invalid': this.validStances != null && !this.validStances.includes(position.key)
      };
    },
    updatePosition(positionKey) {
      if (this.disabled) {
        return;
      }
      this.$emit('input', positionKey);
    },
  },
};
</script>

<style scoped>
.position-selector {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}

.position {
  cursor: pointer;
  position: relative;
  border-radius: 7px;
  margin-left: 0;
  overflow: hidden;
  height: auto;
}

.position:not(:last-child) {
  margin-right: 25px;
}

.position-compact {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.position-compact:not(:last-child) {
  margin-right: 10px;
  cursor: default;
}

.position-label {
  margin-top: 4px;
}
.position-card {
  width: 150px;
  height: 90px;
  background-color: white;
  border: solid 1px #707070;
  border-radius: 7px;
  margin-bottom: 13px;

  display: flex;
  align-items: center;
  justify-content: center;
}
.position-card-compact {
  width: 120px;
  height: 72px;
  margin-bottom: 0px;
  background-color: inherit;
}
.position-card-valid {
  background-color: #84D586;
}
.position-card-invalid {
  background-color: #F92C2D;
}
.position.active .position-card {
  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
  border: solid 3px #56b456;
}

.position-selector.disabled .position {
  cursor: initial;
}

.position-selector.disabled .position-card {
  background: lightgray;
}
</style>